import { render, staticRenderFns } from "./test-video.vue?vue&type=template&id=6da5dccf"
import script from "./test-video.vue?vue&type=script&lang=js"
export * from "./test-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2123933342/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da5dccf')) {
      api.createRecord('6da5dccf', component.options)
    } else {
      api.reload('6da5dccf', component.options)
    }
    module.hot.accept("./test-video.vue?vue&type=template&id=6da5dccf", function () {
      api.rerender('6da5dccf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/test-video.vue"
export default component.exports